import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Card, Form, Button, Grid, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {InputField, DropdownField} from '../../../../common/components/form';
import {paths} from '../../../../common/dictionaries/urls';
import {ERROR_CODES_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import {statusOptions} from '../../../constants';
import './styles.scss';

class ErrorCodeForm extends Component {
  componentDidMount() {
    const {code, permissions} = this.props;
    if (
      !hasAccessPermission(
        permissions,
        resources.WarrantyErrorCodes,
        scopes.Edit
      ) ||
      !hasAccessPermission(
        permissions,
        resources.WarrantyErrorCodes,
        scopes.Create
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    if (code) {
      this.props.fetchWarrantyErrorCode(code);
    }
  }

  onCancelClick = () => {
    this.props.goBack();
  };

  onSubmit = async(formValues) => {
    const {code} = this.props;

    if (code) {
      await this.props.updateWarrantyErrorCode(code, formValues);
    } else {
      await this.props.addWarrantyErrorCode(formValues);
    }
    this.onCancelClick();
  };

  renderForm() {
    const {code, loading} = this.props;

    if (loading) {
      return (
        <Card raised fluid className='warranty-error-codes-form'>
          <Loader active inline='centered' content='Cargando...' />
        </Card>
      );
    }
  
    return (
      <Card raised fluid className="warranty-error-codes-form">
        <Grid textAlign="left">
          <Grid.Row>
            <Grid.Column verticalAlign="middle" width={2}>
              <h4>Código</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name="code"
                type="text"
                component={InputField}
                maxLength={2}
                normalize={(value) => value.toUpperCase()}
                invalidMessage="Por favor, llene este campo"
                required
                disabled={code !== null}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle" width={2}>
              <h4>Descripción</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name="description"
                type="text"
                component={InputField}
                maxLength={30}
                normalize={(value) => value.toUpperCase()}
                invalidMessage="Por favor, llene este campo"
                required
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column verticalAlign="middle" width={2}>
              <h4>Estado</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name="status"
                component={DropdownField}
                options={statusOptions}
                defaultValue={statusOptions[0]}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }

  render() {
    const {handleSubmit, submitting, code} = this.props;

    return (
      <Form
        className="edit-error-code-form"
        onSubmit={handleSubmit(this.onSubmit)}
        loading={submitting}
      >
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>{code ? 'Editar Código' : 'Añadir Código'}</h2>
              <div className="title-bar-actions">
                <Button
                  secondary
                  type="button"
                  onClick={this.onCancelClick}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                <Button primary type="submit" disabled={submitting}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Card>
        {this.renderForm()}
      </Form>
    );
  }
}

export {ErrorCodeForm};

const form = reduxForm({
  'form': ERROR_CODES_FORM.name,
})(ErrorCodeForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'code': ownProps.params.code ? ownProps.params.code : null,
    'push': ownProps.history.push,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'loading': state.errorCodesForm.loading,
  };
};

const {
  fetchWarrantyErrorCode,
  addWarrantyErrorCode,
  updateWarrantyErrorCode,
  withRouter,
  navigateTo,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchWarrantyErrorCode,
    addWarrantyErrorCode,
    updateWarrantyErrorCode,
    navigateTo,
  })(form)
);
